import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import type { SearchFilterNanoID } from '../../../../../../searchFilters/searchFiltersTypes';

import { useTeamShowPage } from '../../../../../hooks/useTeamShowPage';
import { useThirdPersonView } from '../../../../../../../app/hooks/useThirdPersonView';
import { CompanyTabsMenuDropdown } from '../../../../../../companyTabs/components/menus/CompanyTabsMenuDropdown';
import { TeamNanoID } from '../../../../../teamsTypes';
import { TeamPath } from '../../../../../TeamPath';
import { CompanyTabNanoID } from '../../../../../../companyTabs/companyTabsTypes';

interface CompanyTabsDropdownProps {
  teamNanoId: TeamNanoID;
  activeFilterNanoId?: SearchFilterNanoID;
  onDeleteActiveFilter?: () => void;
  withCreateButton: boolean;
  withUpdateButton: boolean;
  withDeleteButton: boolean;
}

function CompanyTabsDropdown({
  teamNanoId,
  activeFilterNanoId,
  onDeleteActiveFilter,
  withCreateButton,
  withUpdateButton,
  withDeleteButton
}: CompanyTabsDropdownProps) {
  const { team } = useTeamShowPage({ teamNanoId });
  const { isThirdPersonView } = useThirdPersonView();
  const router = useRouter();
  const currentTabNanoId = router.query.tabNanoId as CompanyTabNanoID;

  const handleDeleteActiveTab = useCallback(() => {
    if (currentTabNanoId) {
      router.push(
        isThirdPersonView
          ? TeamPath.companyProfile(teamNanoId)
          : TeamPath.currentCompanyProfile()
      );
    } else {
      onDeleteActiveFilter?.();
    }
  }, [
    currentTabNanoId,
    isThirdPersonView,
    router,
    teamNanoId,
    onDeleteActiveFilter
  ]);

  if (!team) {
    return null;
  }

  const activeTabNanoId = activeFilterNanoId || currentTabNanoId;

  return (
    <CompanyTabsMenuDropdown
      activeTabNanoId={activeTabNanoId}
      companyId={team.id}
      companyNanoId={team.nanoId}
      onDeleteActiveTab={handleDeleteActiveTab}
      isMenuOpen
      withCreateButton={withCreateButton}
      withUpdateButton={withUpdateButton}
      withDeleteButton={withDeleteButton}
    />
  );
}

export default CompanyTabsDropdown;
